module.exports = __webpack_public_path__ + "img/calendar.02136c53.png";